import React from "react"
import { isPathAccessDenied, isIntfAccessDenied } from "../../disabledInterfaces"
interface IAccessControl {
  path?: string,
  intf?: string,
  ok: JSX.Element,
  no?: JSX.Element
}

export const AccessControl: React.FC<IAccessControl> = ({ ok, path = "", intf = "", no = <></> }) => {
  let denied = intf != "" ? isIntfAccessDenied(intf) : path != "" ? isPathAccessDenied(path) : false
  return denied ? no : ok
}
